import React from "react";

function Domicilio() {
  return (
    <div className="home">
      <iframe
        title="Domicilio"
        class="video"
        widht="100%"
        height="100%"
        src="https://app.powerbi.com/reportEmbed?reportId=7e7f076f-5833-4535-a933-a9d6bcac5a50&autoAuth=true&ctid=f88c7305-11d1-4b34-a8a0-da6536019e31"
        marginheight="0"
        marginwidth="0"
        scrolling="0"
        frameborder="0"
        allowFullScreen="true"
      ></iframe>
    </div>
  );
}

export default Domicilio;
